import React from "react";

function HomePtext({ children }) {
  return <>{children}</>;
}

export default HomePtext;
